import React from 'react';
export function CityBackdrop({
  imageUrl
}: {
  imageUrl: string;
}) {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-219">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-all duration-1000 ease-in-out" style={{
      backgroundImage: `url('${imageUrl}')`,
      maskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, black 60%, transparent 100%)'
    }} data-id="element-220" />
    </div>;
}